// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { FilterOption } from '@/components/filter-toggle-group';
import { TicketStatus } from '@/ticket/api/types';

export const TICKET_STATUS_OPTIONS: FilterOption<TicketStatus>[] = [
  { value: 'OPEN', label: 'Open tickets' },
  { value: 'CLOSED', label: 'Closed tickets' },
];
